export default __webpack_public_path__ + "static/media/twitter.702f325a.png";